import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { FinancialAsset } from '@app/models/project.models';
import { LabeledContentComponent } from '@app/ui-components/labeled-content/labeled-content.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-not-completed-loan-display',
  imports: [CommonModule, LabeledContentComponent, TranslatePipe],
  templateUrl: './not-completed-loan-display.component.html',
  styleUrl: './not-completed-loan-display.component.scss',
})
export class NotCompletedLoanDisplayComponent {
  /** Not-completed loans from projectDetails.financialAssetsSectionG. */
  assets = input.required<FinancialAsset[]>();

  protected translationKey = 'projectDetails.sectionG.subsectionTwo.';

  /** Loan amount for display (e.g. "1 560 013 Ft"); "—" if not provided. */
  protected loanAmount(asset: FinancialAsset): string {
    if (asset.amount == null) return '—';
    return new Intl.NumberFormat('hu-HU', {
      style: 'decimal',
      maximumFractionDigits: 0,
    }).format(asset.amount) + ' Ft';
  }

  /** Reason for non-performance; "—" if not provided. */
  protected reason(asset: FinancialAsset): string {
    return asset.reason ?? '—';
  }
}
